namespace Matrix.Administration {
    export interface RolePermissionUpdateRequest extends Serenity.ServiceRequest {
        RoleName?: string;
        Permissions?: string[];
    }
}
